import Icon from "@mui/icons-material/Tune";
import TenantSettingsPage from "./TenantSettingsPage";

export default {
  list: TenantSettingsPage,
  icon: Icon,
  label: "App settings",
  options: { label: "App settings" },
  name: "tenantSettings",
};
